import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import ApiContext from "src/provider/API/call-service"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import UserContext from "src/provider/state-manager/userProvider"
import { AbsoluteContainer, AppSpan, AppText, Button, CustomContainer, Form, FormGroup, FormGroupWithIcon, ScreenTitle } from "src/style"
import PopupLockIcon from 'src/assets/svg/forgot-password-lock'
import { AppCenterPopup, CenterPopupHeader } from "src/component"
import { FiChevronDown } from "react-icons/fi"
import { BsEyeSlash, BsEye } from "react-icons/bs"

export const ProfileSecurityQuestion: React.FC<any> = ({close}) => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {logout} = useContext(AppInfoContext)
    const {user: {userInfo}, setUserProperty} = useContext(UserContext)
    const [input, setInput] = useState({
        securityQuestion1: '', securityAnswer1: '', 
        securityQuestion2: '', securityAnswer2: '',
        username: ''
    })
    const [allSecurityQuestions, setAllSecurityQuestions] = useState<any>(null)
    const [showAnswer, setShowAnswer] = useState({answer1: false, answer2: false})

    useEffect(() => {
        handleFetchSecurityQuestions()
    }, [])

    async function handleFetchSecurityQuestions () {
        const response = await API.getSecurityQuestions()
        if (response) setAllSecurityQuestions(response)
    }

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        if (e.target.name === 'username' && e.target.value.includes(' ')) return false
        setInput({...input, [e.target.name]: e.target.value})
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        const payload: any = {...input}
        if (userInfo?.isUsernameCompatible) delete payload.username

        const response = await API.updateUsernameAndSecurityAnswers(payload)
        if (response) {
            if (!userInfo?.isUsernameCompatible && !userInfo?.profileInfo?.isResetActive) {
                await logout()
                navigate('/login')
                
                return false
            }

            const userProfile = {
                ...userInfo?.profileInfo, 
                isOnboardingCompleted: true, 
                isUsernameCompatible: true
            }
            await setUserProperty('userInfo', {...userInfo, profileInfo: userProfile})
        }
    }

    return (
        <AppCenterPopup height='64.1' zIndex='8' close={close}>
            <CenterPopupHeader icon={<PopupLockIcon className='icon-component'/>} />
            <CustomContainer height="53.1" className='popup-content-container'>
                <CustomContainer topMargin="2">
                    <ScreenTitle textSize="2.2" fontWeight="700" align="center">Security Question</ScreenTitle>
                    <AppText topMargin="2">Please Create your Security Question & Answer</AppText>
                    <Form onSubmit={handleProceed} topMargin='2'>
                        { !userInfo?.isUsernameCompatible &&
                            <FormGroup>
                                <label>New Username</label>
                                <input 
                                    placeholder='Enter New Username' 
                                    name='username'
                                    value={input.username}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                        }
                        <FormGroupWithIcon bottomMargin='2'>
                        <label>Security Question 1</label>
                        <div className='input-with-icon'>
                            <select 
                                name='securityQuestion1'
                                value={input.securityQuestion1}
                                style={{color: input.securityQuestion1 ? '#000000' : '#667085'}}
                                onChange={handleInput}
                                required
                            >
                                <option value="">Select Question</option>
                                {
                                    allSecurityQuestions?.map((item: any, index: number) => {
                                        return (
                                            <option 
                                                value={item.question} 
                                                key={index}
                                                disabled={item.question === input.securityQuestion2}
                                            >
                                                {item.question}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                            <FiChevronDown className="input-with-icon-tag" />
                        </div>
                    </FormGroupWithIcon>
                    <FormGroup>
                        <label>Security Answer 1</label>
                        <input 
                            type={showAnswer.answer1 ? 'text' : 'password'}
                            placeholder='Answer' 
                            name='securityAnswer1'
                            value={input.securityAnswer1}
                            onChange={handleInput}
                            autoComplete="off"
                            required
                        />
                        { !showAnswer.answer1 ?
                            <AbsoluteContainer bottom='1.2' right='1'>
                                <AppSpan 
                                    color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                    onClick={() => setShowAnswer({...showAnswer, answer1: true})}
                                >
                                    <BsEyeSlash/>
                                </AppSpan>
                            </AbsoluteContainer>
                            :
                            <AbsoluteContainer bottom='1.2' right='1'>
                                <AppSpan 
                                    color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                    onClick={() => setShowAnswer({...showAnswer, answer1: false})}
                                >
                                    <BsEye/>
                                </AppSpan>
                            </AbsoluteContainer>
                        }
                    </FormGroup>
                    <FormGroupWithIcon bottomMargin='2'>
                        <label>Security Question 2</label>
                        <div className='input-with-icon'>
                            <select 
                                name='securityQuestion2'
                                value={input.securityQuestion2}
                                style={{color: input.securityQuestion2 ? '#000000' : '#667085'}}
                                onChange={handleInput}
                                required
                            >
                                <option value="">Select Question</option>
                                {
                                    allSecurityQuestions?.map((item: any, index: number) => {
                                        return (
                                            <option 
                                                value={item.question} 
                                                key={index}
                                                disabled={item.question === input.securityQuestion1}
                                            >
                                                {item.question}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                            <FiChevronDown className="input-with-icon-tag" />
                        </div>
                    </FormGroupWithIcon>
                    <FormGroup>
                        <label>Security Answer 2</label>
                        <input
                            type={showAnswer.answer2 ? 'text' : 'password'}
                            placeholder='Answer' 
                            name='securityAnswer2'
                            value={input.securityAnswer2}
                            onChange={handleInput}
                            autoComplete="off"
                            required
                        />
                        { !showAnswer.answer2 ?
                            <AbsoluteContainer bottom='1.2' right='1'>
                                <AppSpan 
                                    color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                    onClick={() => setShowAnswer({...showAnswer, answer2: true})}
                                >
                                    <BsEyeSlash/>
                                </AppSpan>
                            </AbsoluteContainer>
                            :
                            <AbsoluteContainer bottom='1.2' right='1'>
                                <AppSpan 
                                    color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                    onClick={() => setShowAnswer({...showAnswer, answer2: false})}
                                >
                                    <BsEye/>
                                </AppSpan>
                            </AbsoluteContainer>
                        }
                    </FormGroup> 
                        <Button 
                            width='100' sizeUnit="%" height='4.4' 
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F'
                        >
                            Proceed
                        </Button>
                    </Form>
                </CustomContainer>
            </CustomContainer>
        </AppCenterPopup>
    )
}